"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.compareValues = void 0;
const compareValues = (a, b, orderDirection) => {
    const [first, second] = orderDirection == null || orderDirection === "asc" ? [a, b] : [b, a];
    if (first == null && second == null) {
        return 0;
    }
    if (first == null) {
        return -1;
    }
    if (second == null) {
        return 1;
    }
    if (typeof first === "string" && typeof second === "string") {
        return first.localeCompare(second);
    }
    if (first instanceof Date && second instanceof Date) {
        return first.getTime() - second.getTime();
    }
    if (typeof first === "number" && typeof second === "number") {
        return first - second;
    }
    return String(first).localeCompare(String(second));
};
exports.compareValues = compareValues;
//# sourceMappingURL=compare-values.js.map